import { useState, useEffect, Fragment } from 'react'
import { useDispatch, useSelector } from "react-redux"
import {
  getTermsAndConditionPageData
} from '@src/redux/actions/outerPages'
import {
  Spinner, CardBody, Card, CardHeader
} from "reactstrap"
import style from './style.module.css'
import Header from '../Header'
import Footer from '../Footer'
import TrustedBrands from '../TrustedBrands'
import UsesandFeatures from '../UsesandFeatures'

const TermsAndConditions = () => {
  const [isPageLoading, setIsPageLoading] = useState(false)

  const dispatch = useDispatch()
  const outerPagesStoreSlice = useSelector(store => store.outerPages)

  useEffect(() => {
    if (!!outerPagesStoreSlice?.termsAndConditionPageInfo) {
      setIsPageLoading(false)
    }
  }, [outerPagesStoreSlice])

  useEffect(() => {
    setIsPageLoading(true)
    dispatch(getTermsAndConditionPageData())
  }, [])

  return (
    <Fragment>
      <Header />
      <div className={style.container}>
        <Card className="mb-0">
          <CardHeader>
            <h3>Terms and Conditions</h3>
          </CardHeader>
          <CardBody>
            {isPageLoading && (
              <div className="w-100 my-4 text-center">
                <Spinner color='primary' />
              </div>)}
            {!isPageLoading && (
              <div dangerouslySetInnerHTML={{ __html: outerPagesStoreSlice?.termsAndConditionPageInfo?.data }} />
            )}
          </CardBody>
        </Card>
      </div>
      <Footer />
    </Fragment>
  )
}

export default TermsAndConditions
